import jQuery from 'jquery'
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import CustomAnimation from '../animation/customAnimation';
import Splide from '@splidejs/splide';
//import { Modal } from 'bootstrap'

let splide1;
let pageRady = false;
const customAnmation = new CustomAnimation();
//let myModal = new Modal(document.getElementById('newsletterModal'));
let showNewsletter = true;//jQuery('.overview').data('show-newsletter');

function showOverviewBg(index) {
  jQuery('.overview_background').removeClass('show');
  jQuery('.overview_background_'+index).addClass('show');
}

class Homepage {
  init() {
    this.initPage();
    this.initParallax();
    this.onScroll();
  }

  initPage = () => {
    $(window).scrollTop(0);
    setTimeout(function () {
      pageRady = true;
    }, 500);

    splide1 = new Splide('.splide_01', {
      type: 'loop',
      perPage: 3,
      focus: 'center',
      autoplay: false,
      flickMaxPages: 3,
      updateOnMove: true,
      pagination: true,
      throttle: 300,
      breakpoints: {
        991: {
          perPage: 1,
        },
        768: {
          perPage: 1,
        },
      }
    });

    splide1.on( 'move', function (newIndex) {
      showOverviewBg(newIndex);
    } );
    splide1.mount();

    setTimeout(function () {
      splide1.refresh();
    }, 500);


    // bg
    showOverviewBg(0);
    jQuery('.header_background').css("background-image", "url("+ jQuery('.header_background').data('bg-image') +")");
    jQuery('.business_boost_background').css("background-image", "url("+ jQuery('.business_boost_background').data('bg-image') +")");
    jQuery('.gettogether_background').css("background-image", "url("+ jQuery('.gettogether_background').data('bg-image') +")");
    jQuery('.newsletter').css("background-image", "url("+ jQuery('.newsletter_background').data('bg-image') +")");
    $('.overview_background').each(function() {
      jQuery(this).css("background-image", "url("+ jQuery(this).data('bg-image') +")");
    });

    // newsletter_close_button
    jQuery('.newsletter_close_button').click(function() {
      jQuery('.newsletter_layer').removeClass('show');
    });
  }

  initParallax = () =>  {
    gsap.registerPlugin(ScrollTrigger);

    customAnmation.animateHeaderImage('.header_background');
    customAnmation.animateBgImage('.business_boost_background', '.business_boost');
    customAnmation.animateText('.business_boost_text_holder');
    customAnmation.animateGroup('.business_boost_box');
    customAnmation.animateButtonHolder('.button_holder_business_boost');
    customAnmation.animateText('.overview_text_holder');
    customAnmation.animateGroup('.overview_box_holder');
    customAnmation.animateButtonHolder('.button_holder_overview');
    customAnmation.animateBgImage('.gettogether_background', '.gettogether');
    customAnmation.animateFromLeft('.gettogether_image');
    customAnmation.animateFromRight('.gettogether_text');
  }

  onScroll = () => {
    jQuery(window)
      .scroll(function () {
        var newsletterLayerHeight = jQuery('.newsletter_layer_form').height() + 250;
        jQuery('.newsletter_layer').css("height", + newsletterLayerHeight + 'px');

        //var scrollHeight = $(document).height();
        //var scrollPosition = $(window).height() + $(window).scrollTop();
        let positionTop = jQuery('.overview').offset().top - 100;

        //if ((scrollHeight - scrollPosition) / scrollHeight === 0 && showNewsletter == true) {
        if($(window).scrollTop() > positionTop && showNewsletter == true && pageRady == true) {
          jQuery('.newsletter_layer').addClass('show');
          showNewsletter = false;
        }
      }).scroll();
  };
}

export default Homepage;
